import CreationToolSuperCutField from '../../../types/super-cut-field'
import SuperCutToolTip from '../../supercut/shared/components/tooltip'

type Props = {
    field: CreationToolSuperCutField
}

const CreationToolSuperCutFieldHelp = ({ field }: Props) => {
    const tooltipText = CreationToolSuperCutField.tooltipText(field)
    const learnMoreUrl = CreationToolSuperCutField.learnMoreUrl(field)

    return tooltipText ? <SuperCutToolTip text={tooltipText} link={learnMoreUrl || undefined} /> : null
}

export default CreationToolSuperCutFieldHelp
